import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const glaucoma: AnswerPathTreeNode = {
  path: 'glaucoma',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredGlaucomaDetails }],
};
